import { createContext } from 'react';
export const NumberedAccordionItemContext = createContext({ isExpanded: false, isDisabled: false });
